import React, { useState } from 'react';

/**
 * Kip mascot mark for chrome (header / favicon companion).
 * Prefers assets dropped by the local Sites worker under public/kip/.
 * Falls back to a simple letterform until those files land on this branch.
 */
const CANDIDATES = [
  '/kip/kip.svg',
  '/kip/kip.png',
  '/kip/kip.webp',
  '/kip/favicon.ico',
  '/kip.png',
  '/kip.svg',
  '/kip.webp',
];

export default function KipMark({ size = 32, alt = 'Kip' }) {
  const [index, setIndex] = useState(0);

  if (index >= CANDIDATES.length) {
    return (
      <span
        aria-label={alt}
        style={{
          width: size,
          height: size,
          borderRadius: 'var(--radius-md)',
          background: 'var(--color-accent-solid)',
          color: 'var(--color-text-on-accent)',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'var(--font-display)',
          fontSize: Math.max(12, size * 0.45),
          fontWeight: 700,
          flexShrink: 0,
        }}
      >
        K
      </span>
    );
  }

  return (
    <img
      src={CANDIDATES[index]}
      alt={alt}
      width={size}
      height={size}
      onError={() => setIndex((i) => i + 1)}
      style={{
        width: size,
        height: size,
        objectFit: 'contain',
        borderRadius: 'var(--radius-sm)',
        flexShrink: 0,
      }}
    />
  );
}
